/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 *
 */

import { AttributeMetadata } from "../../sina/AttributeMetadata";

export interface ITemplateMetadata {
    // folklorists
    metadata: Array<AttributeMetadata>;
    // urban legends
    metadata2: Array<AttributeMetadata>;
    // publications
    metadata3: Array<AttributeMetadata>;
}
